module.exports = __webpack_public_path__ + "media/SessionStartSoundGoodThingsAhead.fc08b82b.mp3";